<template>
  <section class="default-navbar" id="top-navbar-view">
    <el-row type="flex" align="middle">
      <el-col :span="8">
        <ul class="navbar-logo-grid">
          <li>
            <div class="logo">
              <router-link to="/labs">
                <img
                  src="@/assets/images/labSquire-logo.svg"
                  alt="labsquire-logo"
                  class="img-fluid"
                />
              </router-link>
            </div>
          </li>
          <li>
            <div class="menu-toggle-button">
              <span class="el-dropdown-link">
                <img
                  src="../assets/images/dashboard-icon.svg"
                  alt="dashboard-icon"
                />
              </span>
            </div>
          </li>
          <li>
            <div class="title">
              <h3>
                {{ getTitle }}
              </h3>
            </div>
          </li>
          <li v-if="userRoutes.indexOf($route.name) != -1">
            <div class="title">
              <LabInformation></LabInformation>
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :span="9">
        <div class="navbar-filters">
        </div>
      </el-col>
      <el-col :span="7">
        <ul class="navbar-action-grid">
          <li v-if="labRoutes.indexOf($route.name) == -1">
            <div class="navbar-back-navigation">
              <GoBackButton></GoBackButton>
            </div>
          </li>
          <li v-if="$route.name == 'AllLabs'">
            <div class="new-case-button">
              <el-button @click="addNewLab" class="nav-btn">
                <span class="plus-icon"
                  ><img
                    src="../assets/images/icons/plus-icon.svg"
                    alt="" /></span
                >Add New Lab
              </el-button>
            </div>
          </li>
          <li v-if="$route.name == 'TestPanel'">
            <div class="new-case-button">
              <el-button @click="addNewTestPanel" class="nav-btn">
                <span class="plus-icon"
                  ><img src="../assets/images/icons/plus-icon.svg" alt=""
                /></span>
                Add New Test Panel
              </el-button>
            </div>
          </li>

          <li v-if="$route.name == 'LabUsers'">
            <div class="new-case-button">
              <el-button @click="addLabUser" class="nav-btn">
                <span class="plus-icon"
                  ><img src="../assets/images/icons/plus-icon.svg" alt=""
                /></span>
                Add Lab User
              </el-button>
            </div>
          </li>
          <li>
            <div class="notification-block">
              <img src="../assets/images/icons/setting.svg" />
            </div>
          </li>

          <li>
            <div class="avatar profile-dropdown">
              <el-dropdown
                popper-class="profile-dropdown-new"
                placement="bottom-start"
              >
                <el-button>
                  <el-avatar
                    :size="35"
                    src="@/assets/images/avatar-profile.jpg"
                  >
                    <img class="profile-image" :src="snapUrl" /> </el-avatar
                ></el-button>

                <template #dropdown>
                  <el-dropdown-menu class="login-profile" placement>
                    <div id="profile">
                      <div class="profile-pop">
                        <div class="dropdown-profile-img" v-if="snapUrl">
                          <el-avatar :size="100">
                            <img
                              :src="snapUrl"
                              alt="profile"
                              class="profile-image"
                            />
                          </el-avatar>
                        </div>

                        <div class="edit-icon">
                          <img
                            src="@/assets/images/icons/profile/edit-profile-pic.svg"
                            alt="edit-pic"
                          />
                        </div>
                        <el-dropdown-item class="profile-content">
                          <h3 v-if="getAuthenticatedUser">
                            {{ this.getProfileUserNameForHeader }}
                          </h3>
                          <p>
                            {{
                              userTypeMap[this.getProfileDesignationForHeader]
                            }}
                          </p>
                        </el-dropdown-item>
                        <div class="username">
                          <el-button @click="viewProfile()">
                            <div>
                              <ul>
                                <li>
                                  <span
                                    ><img
                                      src="@/assets/images/icons/profile/user-profile.svg"
                                      alt="user-profile"
                                  /></span>
                                  <h4>View Profile</h4>
                                </li>
                              </ul>
                            </div>
                          </el-button>

                          <el-button @click="logOut()">
                            <ul>
                              <li>
                                <span
                                  ><img
                                    class="logout"
                                    src="@/assets/images/icons/profile/log-out.svg"
                                    alt="log-out"
                                /></span>
                                <h4>Log Out</h4>
                              </li>
                            </ul>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </li>
          <li>
            <div class="notification-block">
              <el-dropdown>
                <el-button>
                  <img src="../assets/images/icons/active.svg" />
                </el-button>
                <template #dropdown>
                  <div id="notification">
                    <div class="head">
                      <ul>
                        <li>
                          <h4>
                            <span
                              ><img
                                src="@/assets/images/icons/notification/bell-icon.svg"
                                alt="bell-icon" /></span
                            >Notification
                          </h4>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                    <div class="notification-msg">
                      <ul>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/notification-emoji.svg"
                            alt="notification-emoji"
                          />
                        </li>
                        <li>
                          <h4>Almost done!</h4>
                          <p>
                            Complete registration of<br />
                            your business profile to<br />start work.
                          </p>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/msg-cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                    <div class="notification-msg">
                      <ul>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/notification-emoji.svg"
                            alt="notification-emoji"
                          />
                        </li>
                        <li>
                          <h4>Almost done!</h4>
                          <p>
                            Complete registration of<br />
                            your business profile to<br />start work.
                          </p>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/msg-cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                    <div class="notification-msg">
                      <ul>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/notification-emoji.svg"
                            alt="notification-emoji"
                          />
                        </li>
                        <li>
                          <h4>Almost done!</h4>
                          <p>
                            Complete registration of<br />
                            your business profile to<br />start work.
                          </p>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/msg-cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
              </el-dropdown>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <!-- Mega Dropdown UI -->
    <div id="navigation-toggle">
      <el-drawer v-model="menuNavigation" size="100%" direction="ttb">
        <span>
          <div class="menu-inner-view">
            <el-row>
              <el-col :span="4" class="menu-logo">
                <div class="logo image-fluid">
                  <img src="../assets/images/icons/labsquire-logo.svg" alt="" />
                </div>

                <div class="menu" @click="menuNavigation = false">
                  <div class="menu-toogle-button">
                    <img
                      src="../assets/images/icons/dashboard-icon.svg"
                      alt=""
                    />
                  </div></div
              ></el-col>
              <el-col :span="18" class="menu-search"
                ><div class="cases-button">
                  <h2>MENU</h2>
                </div>
                <div class="form-group">
                  <el-input placeholder="Search" clearable></el-input>
                  <span>
                    <img
                      src="@/assets/images/search-icon.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </div>
              </el-col>
              <el-col :span="2" class="drawer-close-button">
                <el-button @click="menuNavigation = false">
                  <span>
                    <img
                      src="@/assets/images/close-icon.svg"
                      alt="icon"
                      class="img-fluid"
                    /> </span
                ></el-button>
              </el-col>
            </el-row></div
        ></span>
        <NavigationMenu></NavigationMenu>
      </el-drawer>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import appConfig from "@/config/app";
// import Title from "@/components/navbar/title";
import GoBackButton from "@/components/navbar/GoBack";
import LabInformation from "@/components/panels/LabInformation";
import userConstants from "@/config/constants/userConstants";
export default {
  name: "topbar-default",
  data() {
    return {
      title: "",
      imageUrl: "",
      imgSrc: "",
      isOpen: "",
      isCollapse: "",
      routerValue: "",
      offCanvas: "",
      windowWidth: "",
      labRoutes: ["AllLabs", "LabAdmins", "LabManagers"],
      userRoutes: ["TestPanel", "LabUsers"],
      snapUrl: "",
      userTypeMap: userConstants.USER_TYPE_MAP,
    };
  },
  components: {
    // Title,
    GoBackButton,
    LabInformation,
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("profile", [
      "getProfileData",
      "getProfilePicUrlForHeader",
      "getProfileUserNameForHeader",
      "getProfileDesignationForHeader",
    ]),
    getImageUrl() {
      return this.getProfilePicUrlForHeader
        ? this.getProfilePicUrlForHeader
        : appConfig.S3_BUCKET_URL + "/profiles/default-user.png";
    },
    getImgSrc() {
      if (this.$route.path === "/cases") return "Dashboard.svg";
      else if (this.$route.path === "/cases") return "Dashboard.svg";
      return "Dashboard.svg";
    },
    getTitle() {
      if (this.$route.name === "EditLab") return "EDIT LAB";
      else if (this.$route.name === "ViewLab") return "VIEW LAB";
      else if (this.$route.name === "LabAdmins") return "LAB ADMINS";
      else if (this.$route.name === "AllLabs") return "LABS";
      else if (this.$route.meta.title) {
        return this.$route.meta.title;
      } else return null;
    },
  },

  async mounted() {
    await this.$store.dispatch("profile/getProfile");
    this.title = this.$route.meta.title || "Dashboard";
    if (this.getProfileData && this.getProfileData.avatar) {
      this.snapUrl = this.getProfileData.avatar;
    }
  },
  watch: {
    $route(data) {
      this.title = data.meta.title || "Dashboard";
    },
  },
  methods: {
    async logOut() {
      await this.$store.dispatch("globalReset");
      this.$router.push("/signin");
    },
    viewProfile() {
      this.$router.push("/user-profile");
    },
    addNewLab() {
      this.$router.push({ path: "/add-lab" });
    },
    addLabUser() {
      this.$router.push({
        name: "AddLabUsers",
        params: {
          lab_id: this.$route.params.lab_id,
        },
      });
    },
    addNewTestPanel() {
      let query = {
        ...this.$route.query,
        add_panels: true,
      };
      this.$router.push({ query });
    },
  },
};
</script>

<style lang="scss">
.default-navbar {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  padding: 5px 30px 7px 30px;
  .navbar-logo-grid {
    display: flex;
    align-items: center;
    li {
      &:not(:last-child) {
        margin-right: 20px;
      }
      .logo {
        img {
          width: 150px;
          margin-top: 5px;
        }
      }
      .menu-toggle-button {
        margin-bottom: -5px;
        .el-dropdown-menu {
          padding: 0;
        }
      }
      .nav-title {
        h3 {
          font-size: 1em;
          color: #363636;
          font-weight: 600;
          white-space: nowrap;
        }
      }
    }
  }

  .navbar-action-grid {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    li {
      &:not(:last-child) {
        margin-right: 25px;
      }
      .new-case-button {
        button {
          padding: 7px 10px;
          background: rgba(199, 208, 248, 0.4);
          border-radius: 5px;
          min-height: auto;
          color: #273480;
          font-weight: 500;
          border: none;

          span {
            &:nth-child(1) {
              display: flex;
              align-items: center;
              img {
                width: 15px;
              }
            }
          }
          .plus-icon {
            margin-right: 7px;
          }
        }
      }
      .global-search {
        img {
          width: 30px;
          height: 30px;
          margin-bottom: -6px;
        }
      }
      .profile-dropdown,
      .notification-block {
        margin-bottom: -8px;
        .el-button {
          padding: 0;
          border: none;
          min-height: auto;
          background: none;
          .el-avatar {
            width: 32px !important;
            height: 32px !important;
            border-radius: 50%;
            img {
              width: 100%;

              object-fit: cover;
            }
          }
        }
      }
    }
  }
}
#top-navbar-view {
  box-sizing: border-box;
  .top-navbar-view-inner {
    .left-nav {
      justify-content: space-around;
      display: flex;
      align-items: center;
      .logo {
        img {
          width: 150px;
        }
      }
      menu {
        position: relative;
        top: 3px;
      }
    }
    .center-nav {
      .nav-center-block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        min-height: 45px;
        max-height: 100%;
        h3 {
          color: #0a5da6;
          font-weight: 900;
          font-size: 16px;
        }
      }
    }
    .right-nav {
      justify-content: flex-end;
      display: flex;

      .block {
        position: relative;
        margin: 0 1.5em 0 0.5em;

        top: 11px;
      }
      .avatar {
        .el-button {
          border: none;
          padding: 0;
          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }
}
#navigation-toggle {
  @mixin search-bar {
    border-radius: 20px;
    height: 38px;
  }
  .menu-inner-view {
    height: 50px;
    padding: 15px 20px 0 20px;
    .menu-logo {
      display: flex;

      justify-content: space-around;
      .logo {
        padding: 0 2rem;
      }
    }
    .menu-search {
      display: flex;
      justify-content: space-between;

      padding: 0px 10px;
      h2 {
        padding: 9px 14px;
        color: #0a5da6;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
  .form-group {
    display: flex;
    width: 25%;

    span {
      position: relative;
      top: 5px;
      width: 30px;
      border-radius: 50%;
      right: 32px;
    }

    .el-input--suffix .el-input__inner {
      @include search-bar;
    }
  }
  .el-drawer__header {
    display: none;
  }
  .drawer-close-button {
    text-align: end;
    padding: 0 10px;
    display: flex;
    justify-content: flex-end;

    .el-button {
      border: none;
      padding: 0;
      &:active:hover {
        background: transparent;
      }
    }
  }
}

// profile
.el-dropdown__popper.el-popper[role="tooltip"] {
  z-index: 2129;
  position: absolute;
  left: 1266px;
  top: 59.3333px;
  margin: 0px;
}
.login-profile {
  border: 1px solid rgb(86, 204, 242) !important;
  border-radius: 5px;
}
#profile {
  padding-top: 5px;

  .profile-pop {
    background-color: white;
    border: none;
    border-radius: 10px;
    max-width: 180px;
    padding: 5px 10px;
    text-align: center;
    height: 100%;
    .profile-image {
      img {
        width: 90px;
        height: 100px;
      }
    }

    .edit-icon {
      img {
        position: relative;
        left: 1px;
        top: -14px;
        width: 21px;
        height: 18px;
      }
    }
    .profile-content {
      margin-top: -13px;
      display: block;
      line-height: 20px;
      &:hover {
        background-color: #fff;
      }
      h3 {
        font-size: 17px;
        font-weight: 500;
        color: #4f4f4f;
      }
      p {
        font-weight: 500;
        font-size: 14px;
        color: #828282;
      }
    }
    .username {
      padding: 0 5px;
      .el-button {
        padding: 8px 10px;
        width: 100%;
        min-height: 30px;
        margin: 0;
        border: none;
        &:hover,
        &:focus {
          background-color: white;
        }
      }
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          h4 {
            font-size: 14px;
            margin-left: 12px;
            color: #4f4f4f;
          }
        }
      }
      .log-out {
        margin-left: 1px;
      }
    }
    .password {
      .el-button {
        min-height: 30px;
        :hover {
          background-color: white;
        }
        li {
          margin: 5px;
          display: flex;
          align-items: center;
          padding: 0;
        }
        .log-out {
          padding-right: 68px;
        }
        h4 {
          font-size: 14px;
          color: #4f4f4f;

          .log-out {
            padding-left: 20px;
          }

          img {
            margin: 0px 9px -4px -1px;
          }
        }
      }
    }
  }
  .dropdown-profile-img {
    .el-avatar > img {
      width: 100% !important;
      object-fit: cover;
    }
  }
}

// notification//
.notification-block {
  .el-button {
    margin: 0 6px;

    border: none;
    &:hover,
    &:focus {
      background-color: white;
      border: #e5e5e5;
    }
  }
}

#notification {
  width: 250px;
  .head {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #c7d0f826;
      padding: 10px 14px;
      li {
        h4 {
          font-size: 14px;
          img {
            margin-bottom: -3px;
            margin-right: 10px;
          }
          p {
            line-height: 17px;
          }
        }
      }
    }
  }
  .notification-msg {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 10px;
      margin: 11px 20px;
      border: 1px solid #c7d0f8;
      background-color: rgba(199, 208, 248, 0.15);
      border-radius: 5px;
      li {
        p {
          line-height: 14px;
          font-size: 9px;
        }
      }
    }
  }
}
.block {
  .el-popper__arrow::before {
    width: 0px;
    height: 0px;
    box-sizing: none;
  }
}
</style>
